export default __webpack_public_path__ + "static/media/Qais.62cd261a.jpg";